export default "__VITE_ASSET__MtKI4NDo__"